import React from 'react';
import { getAvailableThemes } from '../../../config/themes';

const ThemeSelector = ({ currentThemeId, onThemeChange }) => {
  const themes = getAvailableThemes();

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '6px' }}>
      {themes.map((theme) => (
        <button
          key={theme.id}
          onClick={() => onThemeChange(theme.id)}
          title={`${theme.name} - ${theme.description}`}
          style={{
            padding: '8px',
            border: currentThemeId === theme.id ? '2px solid #3B82F6' : '1px solid #D1D5DB',
            borderRadius: '6px',
            backgroundColor: currentThemeId === theme.id ? '#EFF6FF' : '#FFFFFF',
            cursor: 'pointer',
            textAlign: 'center',
            transition: 'all 0.2s ease',
            height: '48px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px'
          }}
        >
          <div
            style={{
              width: '24px',
              height: '24px',
              borderRadius: '4px',
              backgroundColor: theme.colors.primary,
              border: '1px solid rgba(0,0,0,0.1)'
            }}
          />
          <div style={{ fontSize: '9px', fontWeight: '600', color: '#6B7280' }}>
            {theme.name}
          </div>
        </button>
      ))}
    </div>
  );
};

export default ThemeSelector;
